'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _productLabelPreview = require('./product-label-preview.html');

var _productLabelPreview2 = _interopRequireDefault(_productLabelPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _productLabelPreview2.default,
  bindings: {
    product: '<'
  },
  controller: function () {
    function ProductLabelDownloadComponent($log, ameLightbox, ProductsService, ToastService) {
      'ngInject';

      _classCallCheck(this, ProductLabelDownloadComponent);

      Object.assign(this, {
        $log: $log,
        ameLightbox: ameLightbox,
        ProductsService: ProductsService,
        ToastService: ToastService
      });
    }

    _createClass(ProductLabelDownloadComponent, [{
      key: '$onInit',
      value: function $onInit() {
        var _this = this;

        if (this.product.hasPDFLabel) {
          this.ProductsService.getLabel(this.product.ProductId).then(function (r) {
            _this.label = r.data;
          }).catch(function () {
            _this.$log.error('Unable to get product label PDF download link! Product ID: ' + _this.product.ProductId + ')');
          });
        } else {
          this.ProductsService.getLabelThumbnail(this.product.ProductId).then(function (r) {
            _this.imageArr = r.data;
          }).catch(function () {
            _this.$log.error('Unable to get product label thumbnail! Product ID: ' + _this.product.ProductId + ')');
          });
        }
      }
    }, {
      key: 'previewLabelImage',
      value: function previewLabelImage(productId) {
        var _this2 = this;

        this.ProductsService.getLabelImage(productId).then(function (r) {
          _this2.ameLightbox.show([r.data], {
            buttonClass: 'ng-hide',
            keyboard: false,
            showDots: false
          });
        }).catch(function (error) {
          return _this2.ToastService.showError(error);
        });
      }
    }]);

    return ProductLabelDownloadComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/products/product-label-preview/product-label-preview.component.js